import { render, staticRenderFns } from "./AppointmentDatePreselectionStep.vue?vue&type=template&id=28b78f86"
import script from "./AppointmentDatePreselectionStep.vue?vue&type=script&lang=ts"
export * from "./AppointmentDatePreselectionStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports